function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import NavTab from './NavTab';
import { Dropdown } from '../../Dropdown';
import { Notification } from '../../Notification';
import { HeaderItems } from '../helper';
function NavAction(props) {
  const {
    type = '',
    data = {},
    active = false,
    isMobile = false
  } = props;
  const navbarControlClasses = classNames({
    'sib-navbar-control': true,
    active: active
  });
  const getAction = () => {
    switch (type) {
      case HeaderItems.TAB:
        {
          return /*#__PURE__*/React.createElement(NavTab, _extends({}, data, {
            isMobile: isMobile
          }));
        }
      case HeaderItems.DROPDOWN:
        {
          return /*#__PURE__*/React.createElement(Dropdown, _extends({}, data, {
            isMobile: isMobile
          }));
        }
      case HeaderItems.NOTIFICATION:
        {
          return /*#__PURE__*/React.createElement(Notification, _extends({}, data, {
            isMobile: isMobile
          }));
        }
      default:
        {
          return null;
        }
    }
  };
  return /*#__PURE__*/React.createElement("li", {
    className: navbarControlClasses
  }, getAction());
}
NavAction.propTypes = {
  type: PropTypes.string,
  data: PropTypes.object,
  active: PropTypes.bool,
  isMobile: PropTypes.bool
};
export default NavAction;